'use strict';

var domCache = require('dom-cache');

var dom;
var floatStartY = 140;
var isFloating = false;

var addEventHandlers = function() {

	domCache.window.on('scroll', function() {

		if (!isFloating && window.scrollY > floatStartY) {

			dom.productNav.addClass('product-nav__is-floating');

			isFloating = true;

		}

		else if (isFloating && window.scrollY < floatStartY) {

			dom.productNav.removeClass('product-nav__is-floating');

			isFloating = false;

		}

	});

};

var setupDom = function() {

	dom = {};
	dom.productNav = $('.product-nav-container');

};

var init = function() {

	setupDom();

	addEventHandlers();

};

module.exports = {
	init: init
};